import React, { useState, createContext } from 'react';

export const StartFarmContext = createContext();

//farm steps
function getSteps() {
  return ['Package', 'Configure', 'Pay', 'Confirm'];
}

const StartFarmProvider = ({ children }) => {
  const [activeStep, setActiveStep] = useState(0);
  const [contractModal, setContractModal] = useState(false);
  const [detailsModal, setDetailsModal] = useState(false);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [selectedAcreage, setSelectedAcreage] = useState(1);
  const [cost, setCost] = useState(0);
  const [selectedCycle, setSelectedCycle] = useState(1);

  const handleSelection = _package => {
    setSelectedPackage(_package);
  };

  const handleChange = (e, cost) => {
    if (e.target.name === 'acreage') {
      setCost(cost);
      setSelectedAcreage(parseInt(e.target.value));
    } else {
      setSelectedCycle(parseInt(e.target.value));
    }
  };

  function handleNext() {
    selectedPackage && setActiveStep(prevActiveStep => prevActiveStep + 1);
  }

  function handleBack() {
    setActiveStep(prevActiveStep => prevActiveStep - 1);
  }

  const handleContractModal = () => {
    setContractModal(!contractModal);
  };

  const handleDetailsModal = () => {
    setDetailsModal(!detailsModal);
  };

  const steps = getSteps();

  return (
    <StartFarmContext.Provider
      value={{
        steps,
        setActiveStep,
        selectedPackage,
        handleSelection,
        handleNext,
        handleBack,
        activeStep,
        handleChange,
        setSelectedAcreage,
        selectedAcreage,
        setCost,
        cost,
        setSelectedCycle,
        selectedCycle,
        handleDetailsModal,
        handleContractModal,
        contractModal,
        detailsModal
      }}
    >
      {children}
    </StartFarmContext.Provider>
  );
};

export default StartFarmProvider;
